// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.vrmodel.RentalManagerUserPropertyVrModelWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyVrModelGetAllVrModelsResponseWebDto } from '../..';

interface GetAllVrModelsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path =
  '/api/web/v1/users/properties/vrModel/getAllVrModels';

/**
 * Retrieve all vr models
 */
export const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels = (
  getParams: GetAllVrModelsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetAllVrModelsParams, never, UserPropertyVrModelGetAllVrModelsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
